import { Outlet, useNavigate } from "@tanstack/react-router";
import { Sidebar, MobileHeader } from "@/components/layout/sidebar";
import { CommandPalette } from "@/components/layout/command-palette";
import { BugReportButton } from "@/components/layout/bug-report-button";
import { useSession } from "@/hooks/use-auth";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

/** Straža sesije bez ijednog dijela hroma — koriste je i `AppLayout` (sidebar, header)
 *  i prezentacijski mod, koji ide preko cijelog ekrana bez navigacije. */
export function RequireSession({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate({ to: "/login", replace: true });
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground">Učitavanje...</p>
      </div>
    );
  }

  if (!user) return null;

  return <>{children}</>;
}

export function AppLayout() {
  return (
    <RequireSession>
      <div className="flex h-screen">
        <CommandPalette />
        <BugReportButton />
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <MobileHeader />
          <main className="flex-1 overflow-auto">
            <div className="mx-auto w-full max-w-5xl">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </RequireSession>
  );
}

export function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
